<!--Header responsible for arrows-->
<app-generic-header
  [goBack]="saveChangesButton ? saveButton.bind(this) : exitButton.bind(this)"
  [variant]="
  firstSetup
    ? 'empty'
    : (saveChangesButton ? 'save' : 'back')
">
</app-generic-header>

<ion-content class="ion-padding">

  <div class="centralized">
    
    <div class="page-image">
      <ion-icon src="/assets/imgs/custom-svg/padronized-sizes/activism.svg"></ion-icon>
    </div>

    <div class="page-description">
  {{ 
    "chooseCauses" 
    | translate:{ max: socialCausesService.getSocialCausesData().maxCauses } 
  }}
    </div>

    <div class="causes-container">
      <div 
        *ngFor="let cause of causes" 
        class="cause-chip"
        [class.selected]="isCauseSelected(cause.id)"
        [class.disabled]="!isCauseSelected(cause.id) && selectedCauses.length >= socialCausesService.getSocialCausesData().maxCauses"
        (click)="toggleCause(cause.id)"
      >
        <span class="cause-text">{{ cause.text }}</span>
      </div>
    </div>

    <div class="next-buttons">
      <ion-button fill="outline" mode="md" class="back-button" (click)="backButton()" size="small" value="back" shape="round">
        {{ 'backSurvey' | translate }}
      </ion-button>

      <ion-button color="secondary" mode="md" (click)="nextButton()" size="small" value="next" shape="round">
        {{ 'nextSurvey' | translate }}
      </ion-button>
    </div>

  </div>
  
</ion-content>